/**
 * Force RSI Button Styling on Product Page
 * Overrides any inline styles or scripts from the RSI app
 */

(function() {
  'use strict';

  function forceRSIButtonStyles() {
    // Only run on product pages
    const productSection = document.querySelector('.product-section');
    if (!productSection) return;

    // Find RSI button
    const rsiButton = productSection.querySelector('._rsi-buy-now-button');
    if (!rsiButton) return;

    // Force all styles with !important
    rsiButton.style.setProperty('width', '100%', 'important');
    rsiButton.style.setProperty('min-height', '52px', 'important');
    rsiButton.style.setProperty('padding', '16px 24px', 'important');
    rsiButton.style.setProperty('background', 'white', 'important');
    rsiButton.style.setProperty('background-color', 'white', 'important');
    rsiButton.style.setProperty('color', '#000', 'important');
    rsiButton.style.setProperty('border', '1px solid #000', 'important');
    rsiButton.style.setProperty('border-radius', '0', 'important');
    rsiButton.style.setProperty('box-shadow', 'none', 'important');
    rsiButton.style.setProperty('font-family', "'Inter', -apple-system, BlinkMacSystemFont, sans-serif", 'important');
    rsiButton.style.setProperty('font-size', '14px', 'important');
    rsiButton.style.setProperty('font-weight', '100', 'important');
    rsiButton.style.setProperty('letter-spacing', '5px', 'important');
    rsiButton.style.setProperty('text-transform', 'uppercase', 'important');
    rsiButton.style.setProperty('margin-top', '10px', 'important');
    rsiButton.style.setProperty('transition', 'all 0.2s ease', 'important');
    rsiButton.style.setProperty('display', 'flex', 'important');
    rsiButton.style.setProperty('align-items', 'center', 'important');
    rsiButton.style.setProperty('justify-content', 'center', 'important');
    rsiButton.style.setProperty('cursor', 'pointer', 'important');

    // Hide any icons/SVGs
    const icon = rsiButton.querySelector('svg, ._rsi-button-icon');
    if (icon) {
      icon.style.setProperty('display', 'none', 'important');
    }

    // Add hover effect
    rsiButton.addEventListener('mouseenter', function() {
      this.style.setProperty('background', '#f5f5f5', 'important');
      this.style.setProperty('background-color', '#f5f5f5', 'important');
      this.style.setProperty('border-color', '#000', 'important');
    });

    rsiButton.addEventListener('mouseleave', function() {
      this.style.setProperty('background', 'white', 'important');
      this.style.setProperty('background-color', 'white', 'important');
      this.style.setProperty('border-color', '#000', 'important');
    });

    console.log('✅ RSI button styles forced on product page');
  }

  // Run immediately
  forceRSIButtonStyles();

  // Run after DOM is fully loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', forceRSIButtonStyles);
  }

  // Run after window is fully loaded (after all scripts)
  window.addEventListener('load', function() {
    setTimeout(forceRSIButtonStyles, 100);
    setTimeout(forceRSIButtonStyles, 500);
    setTimeout(forceRSIButtonStyles, 1000);
  });

  // Watch for changes to the button and re-apply styles
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
        forceRSIButtonStyles();
      }
    });
  });

  // Start observing once the product section exists
  function startObserving() {
    const productSection = document.querySelector('.product-section');
    if (productSection) {
      const rsiButton = productSection.querySelector('._rsi-buy-now-button');
      if (rsiButton) {
        observer.observe(rsiButton, {
          attributes: true,
          attributeFilter: ['style']
        });
      }
    }
  }

  // Start observing after a delay to ensure button is rendered
  setTimeout(startObserving, 500);
  setTimeout(startObserving, 1500);
})();
